module.exports = __webpack_public_path__ + "media/src/assets/pro_hopper-67106c1921c545f3f01f22d65cc1b9e2.png";